/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kullanim_S8_I3Inputs */

const tr_kullanim_s8_i3 = /** @type {(inputs: Kullanim_S8_I3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PostgreSQL Row Level Security ile tenant-izolasyonu sağlanır.`)
};

const en_kullanim_s8_i3 = /** @type {(inputs: Kullanim_S8_I3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tenant isolation is ensured with PostgreSQL Row Level Security.`)
};

const de_kullanim_s8_i3 = /** @type {(inputs: Kullanim_S8_I3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Mandantentrennung wird mit PostgreSQL Row Level Security sichergestellt.`)
};

const ru_kullanim_s8_i3 = /** @type {(inputs: Kullanim_S8_I3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изоляция арендаторов обеспечивается с помощью PostgreSQL Row Level Security.`)
};

/**
* | output |
* | --- |
* | "Tenant isolation is ensured with PostgreSQL Row Level Security." |
*
* @param {Kullanim_S8_I3Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kullanim_s8_i3 = /** @type {((inputs?: Kullanim_S8_I3Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kullanim_S8_I3Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kullanim_s8_i3(inputs)
	if (locale === "de") return de_kullanim_s8_i3(inputs)
	if (locale === "ru") return ru_kullanim_s8_i3(inputs)
	return tr_kullanim_s8_i3(inputs)
});